import { Form, InputNumber, Modal, Radio } from 'antd'

interface Props {
  open: boolean
  target: string
  current: number | null | undefined
  inheritLabel: string
  loading: boolean
  onSubmit: (markupPercent: number | null) => Promise<unknown>
  onClose: () => void
}

interface Values {
  mode: 'own' | 'inherit'
  percent?: number
}

export function MarkupModal({
  open,
  target,
  current,
  inheritLabel,
  loading,
  onSubmit,
  onClose,
}: Props) {
  const [form] = Form.useForm<Values>()
  const mode = Form.useWatch('mode', form)
  const percent = Form.useWatch('percent', form)

  const okText =
    mode === 'inherit' ? inheritLabel : `Set markup to ${percent ?? '…'}%`

  const submit = async () => {
    const values = await form.validateFields()
    await onSubmit(values.mode === 'inherit' ? null : (values.percent ?? 0))
    onClose()
  }

  return (
    <Modal
      title={`Change markup — ${target}`}
      open={open}
      okText={okText}
      onOk={() => void submit().catch(() => undefined)}
      onCancel={onClose}
      confirmLoading={loading}
      destroyOnHidden
    >
      <Form<Values>
        form={form}
        layout="vertical"
        preserve={false}
        initialValues={{
          mode: current === null || current === undefined ? 'inherit' : 'own',
          percent: current ?? undefined,
        }}
      >
        <Form.Item name="mode">
          <Radio.Group>
            <Radio value="own">Own markup</Radio>
            <Radio value="inherit">{inheritLabel}</Radio>
          </Radio.Group>
        </Form.Item>
        {mode !== 'inherit' && (
          <Form.Item
            name="percent"
            label="Markup, %"
            rules={[{ required: true, message: 'Enter a markup' }]}
          >
            <InputNumber min={0} max={1000} precision={0} />
          </Form.Item>
        )}
      </Form>
    </Modal>
  )
}
